//import liraries
import React from 'react';
import { Box, Typography, Card, CardMedia, CardContent, Chip, Stack, IconButton } from '@mui/material';
import ShareIcon from '@mui/icons-material/Share';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/rootReducers';
import { useNavigate } from 'react-router-dom';
import { paiseToRupees } from '../../Utils/currencyConverter';

// create a component
const DashboardTripScreen: React.FC = () => {
  const navigate = useNavigate();
  // Get trips from dashboard slice
  const trips = useSelector((state: RootState) => state.dashboard.tripsItinerary);

  return (
    <Box sx={{ mt: 2 }}>
      {/* Header */}
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        <Typography onClick={() => navigate('/trips')} fontWeight={500} sx={{fontSize: '16px', cursor: 'pointer'}}>Trips and Itineraries</Typography>
        <ArrowForwardIosIcon sx={{ fontSize: 14, color: 'text.secondary', ml: 1 }} />
      </Box>

      {/* Horizontal list */}
      <Box
        sx={{
          display: 'flex',
          overflowX: 'auto',
          overflowY: 'hidden',
          gap: 2,
          pb: 2,
          scrollbarWidth: 'none', // Firefox
          msOverflowStyle: 'none', // IE/Edge
          '&::-webkit-scrollbar': {
            display: 'none', // Chrome, Safari and Opera
          },
        }}
      >
        {trips?.map((trip: any) => {
          const imageUrl = trip?.files?.[0]?.fileURL || '';
          const duration = `${trip?.days} Days`;
          const price = trip?.pricePerPerson
            ? `₹${paiseToRupees(trip.pricePerPerson).toFixed(2)}/person`
            : trip?.price || '₹0.00/person';
          const creator = trip?.userId?.firstName || trip?.createdBy || 'Creator';

          return (
            <Box
              key={trip._id}
              sx={{
                flex: '0 0 75%',
                minWidth: 200,
                borderRadius: 4,
                // boxShadow: 3,
                // overflow: 'hidden',
                // backgroundColor: 'red',
              }}
              onClick={() =>{
                if(trip.type == 'trip'){
                  navigate(`/trips/${trip._id}`)
                }else{
                  navigate(`/trips/${trip._id}?type=itinerary`)
                }
                }
                }
            >
              {/* Image section with overlays */}
              <Box sx={{ position: 'relative' }}>
                <CardMedia sx={{ borderRadius: '16px' }} component="img" height="300" image={imageUrl} alt={trip.title} />

                {/* Type label */}
                {trip.type && (
                  <Box
                    sx={{
                      position: 'absolute',
                      top: 0,
                      right: 0,
                      bgcolor: '#FFE0B2',
                      color: '#8B4513',
                      borderRadius: '0 16px 0 16px',
                      px: 2.5,
                      py: 0.5,
                      fontSize: 14,
                      fontWeight: 500,
                    }}
                  >
                    {trip?.type ? `${trip.type.charAt(0).toUpperCase()}${trip.type.slice(1)}` : ''}
                  </Box>
                )}

                {/* Bottom overlays (creator + share) */}
                <Stack
                  direction="row"
                  spacing={1}
                  sx={{
                    position: 'absolute',
                    bottom: 8,
                    left: 8,
                  }}
                >
                  <Chip
                    label={creator}
                    size="small"
                    sx={{
                      bgcolor: 'rgba(255,255,255,0.7)',
                      backdropFilter: 'blur(4px)',
                      fontWeight: 500,
                    }}
                  />
                </Stack>

                <IconButton
                  size="small"
                  sx={{
                    position: 'absolute',
                    bottom: 8,
                    right: 8,
                    bgcolor: 'rgba(255,255,255,0.7)',
                    backdropFilter: 'blur(4px)',
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (navigator.share) {
                      navigator.share({
                        title: trip.title,
                        url: window.location.origin + `/trips/${trip._id}`,
                      });
                    }
                  }}
                >
                  <ShareIcon fontSize="small" />
                </IconButton>
              </Box>

              {/* Details */}
              <Box sx={{ py: 1,px: 2 }}>
                <Typography variant="subtitle1" fontWeight="bold">
                  {trip.title}
                </Typography>
                <Typography variant="body2" color="#008387">
                  {duration} • {price}
                </Typography>
              </Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};


//make this component available to the app
export default DashboardTripScreen;
